"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(input) {
  var inputtedLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var cursorPos = input.selectionStart;
  input.value = input.value.substring(0, cursorPos - inputtedLength) + input.value.substring(cursorPos);
  input.selectionStart = input.selectionEnd = cursorPos - inputtedLength;
}